export type RateType =
  | 'all_in_rate'
  | 'line_hall'
  | 'rate_per_mile'
  | 'rate_per_mile_fsc'
  | 'with_fuel'
  | 'without_fuel'

export const rateTypeMap: Record<RateType, string> = {
  all_in_rate: 'All-in-Rate',
  line_hall: 'Line haul',
  rate_per_mile: 'Rate-per-mile',
  rate_per_mile_fsc: 'Rate-per-mile + FSC',
  with_fuel: 'With Fuel',
  without_fuel: 'Without Fuel',
}

export function getRateType(rateType: RateType) {
  return rateTypeMap[rateType]
}
